<!-- Export Certificate Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="applyFilters()"
               class="form-control form-control-solid w-250px ps-13"
               placeholder="Search certificates..." />
      </div>
    </div>

    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>

        <!-- Add Certificate Button -->
        <button type="button" class="btn btn-sm btn-primary fw-bold d-flex" (click)="openAddCertificateModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Certificate
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body pt-0" *ngIf="showFiltersForm">
    <div class="row mb-6 border rounded p-4 bg-light-primary">
      <div class="col-md-4 mb-3">
        <label class="form-label">Date From</label>
        <input type="date" class="form-control form-control-solid" [(ngModel)]="filters.date_from" />
      </div>
      <div class="col-md-4 mb-3">
        <label class="form-label">Date To</label>
        <input type="date" class="form-control form-control-solid" [(ngModel)]="filters.date_to" />
      </div>
      <div class="col-md-4 mb-3 d-flex align-items-end">
        <button type="button" class="btn btn-primary me-2" (click)="applyFilters()">Apply Filters</button>
        <button type="button" class="btn btn-light" (click)="clearFilters()">Clear</button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Export Certificates Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-125px">Certificate No</th>
            <th class="min-w-125px">Vehicle</th>
            <th class="min-w-125px">Registration No</th>
            <th class="min-w-100px">Engine Model</th>
            <th class="min-w-100px">Fuel Type</th>
            <th class="min-w-100px">Final Date</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="7" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading certificates...
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoading && certificates.length === 0">
            <td colspan="7" class="text-center py-5">
              <div class="text-center">
                <div class="fs-1 fw-bolder text-dark mb-4">No certificates found.</div>
                <div class="fs-6">Start by adding your first export certificate.</div>
              </div>
            </td>
          </tr>
          <!-- Data Rows -->
          <tr *ngFor="let certificate of certificates; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary mb-1 fs-6">
                    {{ certificate.certificate_no || '-' }}
                  </span>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">
                    {{ certificate.reference_number || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary mb-1 fs-6">
                    {{ getVehicleDisplayName(certificate.vehicle) }}
                  </span>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">
                    {{ certificate.vehicle?.car_no || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-bold d-block mb-1 fs-6">
                {{ certificate.registration_no || '-' }}
              </span>
              <span class="text-muted fw-semibold d-block fs-7">
                {{ formatDate(certificate.registration_date) }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ certificate.engine_model || '-' }}
              </span>
            </td>
            <td>
              <span class="badge badge-light-info">
                {{ certificate.classification_of_fuel || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ formatDate(certificate.final_date) }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- View Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-info"
                  (click)="openViewCertificateModal(certificate)"
                  title="View Export Certificate">
                  <i class="ki-duotone ki-eye fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </button>

                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditCertificateModal(certificate)"
                  title="Edit Export Certificate">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="exportCertificate(certificate)"
                  title="Delete Transport Pickup">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && certificates.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
